<template>
    <master-page>
        <br/>
        <v-card>
            <v-card-title style="background: var(--v-primary-base); position: sticky; top: 75px; z-index: 1; color: white !important">
                <v-icon large left style="color: white">mdi-account-child</v-icon>
                <span class="title font-weight-light">Configuração do Relatório de Beneficiário</span>
                <v-spacer/>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="GerarRelatorio()" v-on="on"><v-icon>mdi-text-box-check</v-icon></v-btn>
                    </template>
                    <span>Gerar Relatório</span>
                </v-tooltip>
                <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn fab small depressed="" color="primary" class="mr-2" @click="LimparFiltros()" v-on="on"><v-icon>mdi-eraser</v-icon></v-btn>
                    </template>
                    <span>Limpar</span>
                </v-tooltip>
            </v-card-title>
            <v-card-text class="mt-3">
                <v-row>
                    <v-col cols="12" sm="6" md="6">
                        <v-select v-model="filtro.mesInicial" label="Data de Nascimento Incial" placeholder="SELECIONAR" :items="meses" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-select v-model="filtro.mesFinal" label="Data de Nascimento Final" placeholder="SELECIONAR" :items="meses" item-value="key" item-text="value" dense outlined/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field type="number" v-model.number="filtro.anoInicial" label="Nascidos a partir de: " placeholder="Ano" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field type="number" v-model.number="filtro.anoFinal" label="Nascidos antes de: " placeholder="Ano" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field type="number" v-model.number="filtro.idadeInicial" label="Idade inicial: " placeholder="0" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                        <v-text-field type="number" v-model.number="filtro.idadeFinal" label="Idade final: " placeholder="99" dense outlined/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" sm="12" md="6">
                        <v-autocomplete v-model="filtro.beneficiario" :items="beneficiarios" :loading="isBeneficiarioLoading" :search-input.sync="onSearchBeneficiario" clearable
                          item-text="nome" item-value="nome" label="Nome" dense outlined/>
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-autocomplete v-model="filtro.projetoId" :items="projetos" :loading="isProjetoLoading" :search-input.sync="onSearchProjeto" :disabled="!filtro.modoSimples || !filtro.relacionarProjetos" clearable
                          item-text="codigoNome" item-value="id" label="Projeto" dense outlined/>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6" sm="6" md="3">
                        <v-switch v-model="filtro.modoSimples" :label="filtro.modoSimples ? 'Modo Simples' : 'Modo Completo'" :disabled="filtro.exportarExcel" style="margin-top: -5px"/>
                    </v-col>
                    <v-col cols="6" sm="6" md="3">
                        <v-switch v-model="filtro.exportarExcel" label="Exportar para Excel" style="margin-top: -5px"/>
                    </v-col>
                    <v-col cols="6" sm="6" md="3">
                        <v-switch v-model="filtro.relacionarProjetos" label='Relacionar beneficiários atuais aos projetos' :disabled="!filtro.modoSimples || filtro.exportarExcel" style="margin-top: -5px"/>
                    </v-col>
                    <v-col cols="6" sm="6" md="3">
                        <v-switch v-model="filtro.projetosAbertos" label="Somente projetos abertos" :disabled="!filtro.modoSimples || !filtro.relacionarProjetos" style="margin-top: -5px"/>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </master-page>
</template>

<script>
import { BeneficiarioService, ProjetoService } from '../../../core/services/projetos';
import JSONToCSVConverter from '../../../assets/js/custom'

export default {
    data: () => ({
        filtro: {
            mesInicial: 0,
            mesFinal: 0,
            modoSimples: true,
            exportarExcel: false,
            anoInicial: null,
            anoFinal: null,
            idadeInicial: null,
            idadeFinal: null,
            beneficiario: '',
            projetoId: 0,
            relacionarProjetos: false,
            projetosAbertos: false
        },   
        service: new BeneficiarioService(),     
        meses: [],
        beneficiarios: [],
        isBeneficiarioLoading: false,
        onSearchBeneficiario: null,
        projetoService: new ProjetoService(),
        projetos: [],
        isProjetoLoading: false,
        onSearchProjeto: null,           

    }),
    methods: {
        GerarRelatorio(){
            if(this.filtro.exportarExcel){  

                var filter = {
                    anoInicial: this.filtro.anoInicial,
                    anoFinal: this.filtro.anoFinal,
                    idadeInicial: this.filtro.idadeInicial,
                    idadeFinal: this.filtro.idadeFinal,
                    beneficiario: this.filtro.beneficiario,
                }

                this.service.FiltroComplementar(0,-1,[],[],null,[], filter, this.filtro.mesInicial, this.filtro.mesFinal, this.filtro.anoInicial, this.filtro.anoFinal, this.filtro.idadeInicial, this.filtro.idadeFinal).then(
                    res=>{
                        let lista = res.data;
                        lista.some(x => {
                            x.dataAdesao = new Date(x.dataAdesao).ddmmyyyy();
                            x.dataNascimentoFundacao = new Date(x.dataNascimentoFundacao).ddmmyyyy();
                        });
                        JSONToCSVConverter(lista, "Relatorio_Beneficiario", true);
                    },
                    err=>{
                        this.$swal('Aviso', err.message, 'error');
                    }
                )
            }
            else{
                this.AbrirJanela('relatorioBeneficiario');
            }
            
        },
        LimparFiltros(){
            this.filtro = {
                mesInicial: 0,
                mesFinal: 0,
                modoSimples: true,
                exportarExcel: false,
                anoInicial: null,
                anoFinal: null,
                idadeInicial: null,
                idadeFinal: null,
                beneficiario: '',
                projetoId: 0,
                relacionarProjetos: false,
                projetosAbertos: false
            }
        },
        AbrirJanela(rota) {
            let routeLink = this.$router.resolve({ name: rota,
                query:{
                    mesInicial: this.filtro.mesInicial,
                    mesFinal: this.filtro.mesFinal,
                    modoSimples: this.filtro.modoSimples,
                    anoInicial: this.filtro.anoInicial,
                    anoFinal: this.filtro.anoFinal,
                    idadeInicial: this.filtro.idadeInicial,
                    idadeFinal: this.filtro.idadeFinal,
                    beneficiario: this.filtro.beneficiario,
                    projetoId: this.filtro.projetoId,
                    relacionarProjetos: this.filtro.relacionarProjetos,
                    projetosAbertos: this.filtro.projetosAbertos
                } 
            });
            window.open(routeLink.href,'_blank');
        },
    },
    watch:{
        onSearchBeneficiario(val){
            if(this.isBeneficiarioLoading) return;
            if(!val) return;

            this.isBeneficiarioLoading = true;
            this.service.AutoComplete(val)
            .then(
                res=>{
                    this.beneficiarios = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isBeneficiarioLoading = false))
        },
        onSearchProjeto(val){
            if(this.isProjetoLoading) return;
            if(this.filtro.projetoId) return;
            if(!val) return;

            this.isProjetoLoading = true;
            this.projetoService.AutoComplete(val)
            .then(
                res=>{
                    this.projetos = res.data
                },
                err => this.$swal('Aviso', err.response.data, 'error')
            )
            .finally(() => (this.isProjetoLoading = false))
        },
        'filtro.modoSimples': function() { 
            if(!this.filtro.modoSimples){
                this.filtro.relacionarProjetos = false;
                this.filtro.projetosAbertos = false;
                this.filtro.projetoId = 0;
            }
        },
        'filtro.relacionarProjetos': function() { 
            if(!this.filtro.relacionarProjetos){
                this.filtro.projetosAbertos = false;
                this.filtro.projetoId = 0;
            }
        },
        'filtro.exportarExcel': function() { 
            if(this.filtro.exportarExcel){
                this.filtro.projetoId = 0;
                this.filtro.relacionarProjetos = false;
                this.filtro.modoSimples = true;
                this.filtro.projetosAbertos = false;
            }
        }
    },
    mounted(){
        
        this.meses.push(
            {
                key: 1,
                value: 'Janeiro'
            },
            {
                key: 2,
                value: 'Fevereiro'
            },
            {
                key: 3,
                value: 'Março'
            },
            {
                key: 4,
                value: 'Abril'
            },
            {
                key: 5,
                value: 'Maio'
            },
            {
                key: 6,
                value: 'Junho'
            },
            {
                key: 7,
                value: 'Julho'
            },
            {
                key: 8,
                value: 'Agosto'
            },
            {
                key: 9,
                value: 'Setembro'
            },
            {
                key: 10,
                value: 'Outubro'
            },
            {
                key: 11,
                value: 'Novembro'
            },
            {
                key: 12,
                value: 'Dezembro'
            },
        )
    }
}

</script>